import { api } from "../api/api";
import { tfnwOrdersMockData } from "../util/mock-data/BajaOrdersMockData";

const errorHandler = (error) => {
  if (error?.code?.trim() == "ERR_NETWORK") {
    throw new Error(
      "It looks like we can't reach the server right now. Please try refreshing the page or check after sometime."
    );
  } else {
    throw new Error(error?.response?.data?.title);
  }
};

export const getBajaOrders = async (params) => {
  try {
    const response = await api.get(
      `/api/D365/SalesOrders?shipRequestDate= ${params?.requestedShippingDate}`
    );
    return response.data?.result?.result || [];
  } catch (error) {
    errorHandler(error);
  }
};

export const getDuplicateOrdersByRegionCode = async (params, regionCocde) => {
  try {
    const response = await api.get(`/api/D365/duplicate-sales-orders/${regionCocde}`, {
      params: {
        customers: params?.customers,
        shipDate: params?.shipDate, // format date properly
        linesOfBusiness: params?.linesOfBusiness, // array of strings
        customerGroups: params?.customerGroups,
        invoiceNumbers: params?.invoiceNumbers,
        customerWave: params?.customerWave,
        salesOrigin: params?.salesOrigin
      },
      paramsSerializer: (params) => {
        const query = new URLSearchParams();
        params.customers?.forEach((item) => {
          query.append("customers", item);
        });
         params.customerWave?.forEach((item) => {
          query.append("customerWave", item);
        });
        params.salesOrigin?.forEach((item) => {
          query.append("salesOrigin", item);
        });
        params.customerGroups?.forEach((item) => {
          query.append("customerGroups", item);
        });
        params.invoiceNumbers?.forEach((item) => {
          query.append("invoiceNumbers", item);
        });
        if (params?.shipDate) query.append("shipDate", params?.shipDate);
        params?.linesOfBusiness?.forEach((item) => {
          query.append("linesOfBusiness", item);
        });
        return query.toString();
      }
    });
    return response.data?.result?.result || [];
  } catch (error) {
    errorHandler(error);
  }
};

export const postTfnwOrdersToD365 = async (payload, regionName) => {
  try {
    const response = await api.post(
      `/api/D365/SalesOrders/${regionName}`,
      payload
    );

    return response.data?.result || [];
  } catch (error) {
    errorHandler(error);
  }
};

export const getTfflOrders = async (params) => {
  try {
    const response = await api.get(`/api/D365/tffl-sales-orders`, { params });
    return response.data?.result?.result || [];
  } catch (error) {
    errorHandler(error);
  }
};

export const postTfflOrdersToD365 = async (payload, regionName) => {
  try {
    const response = await api.post(
      `/api/D365/SalesOrders/${regionName}`,
      payload
    );

    return response.data?.result || [];
  } catch (error) {
    errorHandler(error);
  }
};

export const getDuplicateOrders = async (params) => {
  try {
    const response = await api.get(`/api/PurchaseOrder/Duplicates/${params?.region}`, {
      params: params
    });
    return response.data?.result?.result || [];
  } catch (error) {
    errorHandler(error);
  }
};

export const postToD365BajaOrders = async (payload) => {
  try {
    const response = await api.post("/api/D365/SalesOrders", payload);

    return response.data?.result || [];
  } catch (error) {
    errorHandler(error);
  }
};
